import React from "react";
import Header from "./Header";
import MyEntityView from "../myentity/MyEntityView";

export default function LayoutMyEntity() {
  return (
    <>
      <Header />
      <MyEntityView />
    </>
  );
}
